import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREACTIVITIES,
    RETRIEVE_ARCHITECTUREACTIVITIES,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ARCHITECTUREACTIVITIES,
    UPDATE_ARCHITECTUREACTIVITIES,
    DELETE_ARCHITECTUREACTIVITIES,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import ARCActivities from "../service/arcActivities";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCActivities.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCActivities.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREACTIVITIES,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCActivities.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREACTIVITIES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCActivities.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREACTIVITIES,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCActivities.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREACTIVITIES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCActivities.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREACTIVITIES,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCActivities.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREACTIVITIES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};